import React, { useEffect, useState } from 'react'
import CannotProcessFeeView from './components/CannotProcessFeeView'
import Error from 'shared/components/Error'
import { withTranslation } from 'react-i18next'
import { addToGoogleDataLayer } from 'shared/const/utls.js'

const CannotProcessFee = ({ i18n }) => {
  const [isError, setIsError] = useState(false)

  useEffect(() => {
    try {
      addToGoogleDataLayer('cannot-process-fee', 'Pay a Fee for Defaulted Fines', i18n.language)
      window.scrollTo(0, 0)
    } catch (e) {
      console.log(e)
    }
  }, [])

  return isError ? <Error /> : <CannotProcessFeeView setIsError={setIsError} />
}

export default withTranslation('common')(CannotProcessFee)
